import { madSDK } from "../../sdk";
/**
 * Helper to read the current (already-loaded) MadSDK feature-flag state.
 *
 * Note: this does not trigger re-renders when feature flags load; ensure `madSDK.featureFlags.load()` has completed before using this.
 *
 * @param flags One feature-flag key, or an array of keys. Array mode returns true only if every flag is enabled.
 * @returns True if the flag(s) are enabled.
 */
export const useMadSDKFeatureFlag = (flags) => {
    if (Array.isArray(flags)) {
        return flags.every((flag) => madSDK.featureFlags.isFlagEnabled(flag));
    }
    return madSDK.featureFlags.isFlagEnabled(flags);
};
//# sourceMappingURL=useMadSDKFeatureFlag.js.map